export const version = {
  timeStamp: '2026-07-14 07:11:06 AM ',
  version: '0.0.5',
};
